import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of, Subject, from, ReplaySubject } from 'rxjs';
//import { HttpClient, HttpRequest, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, filter } from 'rxjs/operators';

import { UserClaims, Partner, Account } from '@mitel/cloudlink-sdk';

import { environment } from '../../../environments/environment';
import { AccountsService } from './accounts.service';
import { AuthService } from './auth.service';
import { AdminService } from './admin.service';
import { UsersService } from './users.service';
import { AppUserClaimsService } from './app-user-claims.service';
import { PolicyTestRequest } from '@mitel/cloudlink-sdk/authentication';

@Injectable({
	providedIn: 'root'
})

// this service will hide whatever implementation we eventually have for feature toggles
// right now it is static and saved in the environment file
export class MiAccessService {

	constructor(
		private accountSvc: AccountsService,
		private authSvc: AuthService,
		private adminSvc: AdminService,
		private userSvc: UsersService,
		private claimsSvc: AppUserClaimsService
	) {}

	async checkPAOnboarding(accountId) {
		let primeAccountId = this.accountSvc.getPrimeAccountId();
		if (localStorage.getItem('@mitel/token.original_token') && !primeAccountId) {
			let claims;
			try {
				claims = await this.authSvc.getPartnerClaims();
				primeAccountId = claims.role === "PARTNER_ADMIN" ? claims.accountId : primeAccountId; // There is a refresh issue where original_token is storing that of an account_admin
			} catch (err) {
				console.error('cannot get partner claims', err);
			}
		}
		
		if (accountId === primeAccountId) { 
			let tag;
			try {
				tag = await this.adminSvc.getAccountTags(accountId);
				if (tag && tag['on-board-progress']) { // if they have gone through onboarding, allow to show integration
					return true;
				} else {
					return false;
				}
			} catch (err) {
				console.error('cannot get tags:', err);
				return false;
			}
		}

		return true;
	}
}
